import { motion } from "framer-motion";
import { Facebook, Star } from "lucide-react";

export const GOOGLE_URL = "https://share.google/3PAD0QU9c7jXOKj3E";
export const FACEBOOK_URL = "https://www.facebook.com/share/18F1X51zkr/?mibextid=wwXIfr";

export default function Reviews() {
  return (
    <section
      id="reviews"
      className="relative py-24 md:py-32 border-b border-white/10"
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7 }}
              className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#FF6B00] mb-6"
            >
              Word Around Town
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="font-display font-bold uppercase tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight mb-8"
            >
              East TN
              <br />
              <span className="text-[#FF6B00]">trusts us.</span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="text-zinc-400 text-base md:text-lg max-w-md"
            >
              Don't take our word for it — see what your neighbors across
              Knoxville and Maryville say about our work, straight from Google.
            </motion.p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="border border-white/10 bg-[#121212] p-8 md:p-12 rounded-sm"
            data-testid="reviews-card"
          >
            <div className="flex items-end gap-4 mb-4">
              <span className="font-display font-bold text-7xl md:text-8xl leading-none text-white">
                4.8
              </span>
              <div className="pb-2">
                <div className="flex gap-1 mb-2" data-testid="reviews-stars">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-5 h-5 text-[#FF6B00] fill-[#FF6B00]"
                    />
                  ))}
                </div>
                <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                  Based on 20+ Google Reviews
                </p>
              </div>
            </div>
            <p className="text-zinc-400 text-sm md:text-base mb-10 border-t border-white/10 pt-6">
              Real reviews from real East Tennessee homeowners — heating,
              cooling, and everything in between.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={GOOGLE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex items-center justify-center gap-3 bg-[#FF6B00] hover:bg-[#E66000] text-[#050505] font-display font-semibold uppercase tracking-wide px-6 py-4 rounded-sm transition-colors duration-300"
                data-testid="reviews-google-button"
              >
                <Star className="w-5 h-5" strokeWidth={2.5} />
                Google Reviews
              </a>
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex items-center justify-center gap-3 border border-white/20 hover:border-[#FF6B00] hover:text-[#FF6B00] text-white font-display font-semibold uppercase tracking-wide px-6 py-4 rounded-sm transition-colors duration-300"
                data-testid="reviews-facebook-button"
              >
                <Facebook className="w-5 h-5" strokeWidth={2.5} />
                Facebook
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
